import {
  AUTH_EMAIL_LOGIN,
  AUTH_PASSWORD_RESET_CONFIRMATION,
  AUTH_PASSWORD_SHOW
} from 'portal/constants/Routes';

import {
  buttonContainerStyles,
  buttonStyles,
  loginButtonStyles
} from 'auth/AuthStyles';
import { postData } from 'helpers/RequestHelper';
import {
  recaptchaV2,
  showRecaptchaError,
  submitRecaptchaForm,
  validateRecaptchaV2
} from 'helpers/RecaptchaHelpers';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useSelector } from 'react-redux';
import Button from '@opploans/button-component/Button';
import React from 'react';
import RebrandEmail from 'fields/rebrand/RebrandEmail';

function PasswordResetEmailForm({ navigate }) {
  const email = useSelector((state) => state.email);
  const error = useSelector((state) => state.errors.email);
  const [loading, setLoading] = React.useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const requestPasswordReset = async () => {
    const response = await postData({
      url: AUTH_PASSWORD_SHOW,
      body: {
        user: { email }
      }
    });
    if (response.data?.error) {
      window.toastr.error(response.data?.error);
      setLoading(false);
    }
    if (response.data?.redirect) {
      window.location.href = response.data.redirect;
      return;
    }
    if (response.data?.success) {
      window.location.href = AUTH_PASSWORD_RESET_CONFIRMATION;
    }
  };

  const onRecaptchaV2Success = async (token) => {
    const response = await validateRecaptchaV2(token);
    if (response.data?.is_human === true) {
      setLoading(true);
      await requestPasswordReset();
    } else {
      showRecaptchaError();
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    const recaptchaValidationResponse = await submitRecaptchaForm(
      executeRecaptcha,
      email
    );
    if (recaptchaValidationResponse?.human === true) {
      await requestPasswordReset();
    } else {
      setLoading(false);
      recaptchaV2(onRecaptchaV2Success, showRecaptchaError);
      showRecaptchaError();
    }
  };

  return (
    <div
      role='button'
      aria-hidden='true'
      onKeyPress={(e) => {
        if (e.key === 'Enter' && email && !error) {
          onSubmit();
        }
      }}
    >
      <RebrandEmail
        additionalStyle={{
          width: '100%',
          '.MuiOutlinedInput-notchedOutline': {
            border: '1px solid #CACACA'
          }
        }}
        briteVerify={false}
      />
      <div css={buttonContainerStyles}>
        <Button
          css={[loginButtonStyles, { marginTop: '1rem' }]}
          onClick={onSubmit}
          loading={loading}
          disabled={!email || error}
        >
          Send Password Reset Link
        </Button>
        <div id='recaptcha-v2' css={{ margin: '1rem 0' }} />
        <Button css={buttonStyles} onClick={() => navigate(AUTH_EMAIL_LOGIN)}>
          Return to Login
        </Button>
      </div>
    </div>
  );
}

export default PasswordResetEmailForm;
